module.exports = __webpack_public_path__ + "img/FM.dd07ac33.svg";